import { IModelApi, ModelApi, LessonTaskModel, Fetcher } from '@ru-edu/ecl-player';

export type ILessonTaskApi = IModelApi<LessonTaskModel>;

export class LessonTaskApi extends ModelApi<LessonTaskModel> implements ILessonTaskApi {
  constructor(fetcher: Fetcher) {
    super(fetcher, '/api/ecl/tasks');
  }
}
